import PaymentService from './PaymentService';

export default PaymentService;
